import styled from 'styled-components'
import Text from './Text'

const Container = styled.button`
  width: 100%;
  min-height: 50px;
  background-color: ${(props) => props.theme.colors.neutral[100]};
  outline: none; // 기본 css 설정 초기화
  border: 1px solid  ${({ $isActive, theme }) => ($isActive ?  theme.colors.primary : theme.colors.neutral[400])};
  border-radius: 8px;
  cursor: pointer;
`
const SelectableButton = ({label, $isActive , onClick}) => {
  return (
    <Container 
      $isActive={$isActive} 
      onClick={onClick} 
      type="button"
    >
      <Text weight="medium" color="alternative">
        {label}
      </Text>
    </Container>
  )
}

export default SelectableButton
